export default __webpack_public_path__ + "static/Mona-fc863fad941091ebdad07c7bbf2cd5c0.png";